import { Member, MessagingSequencesQuery, Wedding, WeddingWebsiteQuery } from '../../generated/graphql';

// Media ID was found at https://github.com/tkww/guest-messaging/blob/develop/model/sequence/info.go#L36
export const SAVE_THE_DATE_MEDIA_ID = process.env.REACT_APP_SAVE_THE_DATE_MEDIA_ID;
export const SEQUENCE_TYPE_RSVP_REMINDER = 'rsvp-reminder';
export const SEQUENCE_TYPE_RSVP_SCHEDULE = 'rsvp-reminder-scheduled';
export const SEQUENCE_TYPE_SAVE_THE_DATE = 'save-the-date';
export const SEQUENCE_TYPE_ADDRESS_COLLECT = 'collect-addresses';
export const SEQUENCE_TYPE_CUSTOM_MESSAGE = 'custom-message';
export const SEQUENCE_TYPE_SEND_UPDATES = 'send-updates';
export const SEQUENCE_TYPE_SHARE_DAY_OF_DETAILS = 'share-day-of-details';
export const SEQUENCE_TYPE_LOCAL_HOTELS = 'share-local-hotel';
export const INITIALIZED_SEQUENCES = [
  'share-website',
  'rsvp-reminder',
  'send-updates',
  'share-day-of-details',
  'share-local-hotel',
];
export type Sequences = MessagingSequencesQuery['messagingSequences'];
export type Sequence = Sequences[0];
export interface SplitSequences {
  active: Sequences;
  blocked: Sequences;
}

export const getSequences = (sequenceData?: MessagingSequencesQuery, gdsData?: WeddingWebsiteQuery) => {
  if (!sequenceData?.messagingSequences || !gdsData?.weddingWebsite.state) {
    return { active: [], blocked: [] };
  }

  const sequences = sequenceData?.messagingSequences.reduce<SplitSequences>(
    (prev, val) => {
      if (val.sequenceType === SEQUENCE_TYPE_RSVP_SCHEDULE) {
        return {
          ...prev,
        };
      }

      if (
        (gdsData.weddingWebsite.state === 'unpublished' ||
          gdsData.weddingWebsite.state === 'uninitialized' ||
          gdsData.weddingWebsite.state === 'disabled') &&
        INITIALIZED_SEQUENCES.includes(val.sequenceType)
      ) {
        return {
          ...prev,
          blocked: [...prev.blocked, val],
        };
      }

      return {
        ...prev,
        active: [...prev.active, val],
      };
    },
    { active: [], blocked: [] }
  );

  const { active: activeSequences } = sequences;

  // We probably don't want the scenario where the user is
  // double-prompted when landing on MessagingHub.
  //  i.e. Name Prompt modal as required by MessagingHub immediately followed by Wedding Info Prompt modal as required by Save The Date.
  if (activeSequences[0].mediaId === SAVE_THE_DATE_MEDIA_ID && activeSequences.length > 1) {
    activeSequences.splice(0, 2, activeSequences[1], activeSequences[0]);
  }

  return sequences;
};

interface EligibilityFunction {
  (member?: Member | null, wedding?: Pick<Wedding, 'weddingDate'> | null): boolean;
}

// These are the required fields for Save The Date prompt. Wedding Location is an optional field.
export const getSaveTheDateEligibility: EligibilityFunction = (member, wedding) => {
  return Boolean(
    member?.firstName && member?.lastName && member?.fianceFirstName && member?.fianceLastName && wedding?.weddingDate
  );
};

export function getSequenceMap(sequences: SplitSequences, type: 'sms' | 'email') {
  const map = new Map<string, string>();

  sequences.active.forEach(sequence => {
    const typeId = sequence?.supportedTypes?.find(types => types.type === type)?.id;

    if (typeId) {
      map.set(typeId, sequence.mediaId);
    }
  });

  return map;
}

export function keyify(str: string) {
  return str
    .trim()
    .replace(/ /g, '_')
    .toLowerCase();
}
